import Loading from "@/customer/components/Layouts/loading.vue";
import Results from "@/customer/components/Layouts/ResultsLoading.vue";
import * as guards from "@/router/guard";
import HomeLayout from "@/customer/components/Layouts/index.vue";
export const HomeRoute = [

    {
        path: '/home',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ '../customer/views/home.vue'),
        props: true,
        meta: {layout: HomeLayout},
        beforeEnter: guards.MustBeNotShowButtonGauard

    },
    {
        path: '/:product_id/:id',
        name: 'login',
        meta: {layout: Loading},
        component: () => import(/* webpackChunkName: "LoginForm" */ '../customer/components/LoginForm/index.vue'),
    },

    {
        name: 'results',
        path: '/results/:param/:status',
        meta: {layout: Results},
        component: () => import(/* webpackChunkName: "Results" */ '../customer/components/Results/index.vue'),
    },
    {
        name: 'certificate',
        path: '/certificate',
        meta: {layout: Results},
        beforeEnter: guards.Certificate,
        component: () => import(/* webpackChunkName: "Results" */ '../customer/components/Results/certificate.vue'),
    },
    {
        path: '/notifications',
        name: 'notifications',
        meta: {layout: Results},
        component: () => import(/* webpackChunkName: "notifications" */ '../customer/components/notifications/index.vue'),
        beforeEnter: guards.MustBeNotShowButtonGauard,
        props: true,
    },
]